import { BaseText, ListItem, theme } from 'aimo-ui';
import { TitleWrapper } from 'components/account/paymentMethods/PaymentMethodItem';
import Icon from 'components/icons/Icon';
import { noop } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { CompanyBenefit, Maybe } from 'types/generatedSchemaTypes';

type CompanyBenefitItemProps = {
  item: Maybe<CompanyBenefit>;
  indexValue: number;
};

const IconComponent = () => (
  <Icon size="l" name="Service-Filled" color={theme.colors.boost.green} />
);

const TitleComponent = ({ item, indexValue }: CompanyBenefitItemProps) => {
  return (
    <TitleWrapper>
      <StyledWrapper mb={0} maxWidth={230}>
        <BaseText numberOfLines={1} testID={`credit-card-title-${indexValue}`}>
          {item?.name}
        </BaseText>
      </StyledWrapper>
    </TitleWrapper>
  );
};

const CompanyBenefitItem = ({ item, indexValue }: CompanyBenefitItemProps) => {
  const { t } = useTranslation();

  return (
    <ListItem
      item={item}
      accessibilityLabel={`${t('ariaLabels.companyBenefits.companyBenefit')} ${item?.name ?? ''}`}
      indexValue={indexValue}
      onPress={noop}
      iconComponent={IconComponent}
      titleComponent={() => TitleComponent({ item, indexValue })}
    />
  );
};

export default CompanyBenefitItem;
